/**
 *
 * Header
 *
 */

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from '@reduxjs/toolkit';
// import styled from 'styled-components';
import Img from '../Img';
import { getLogoAsPerTheme } from '../../utils/common';

import { handleLanguageSelectModal } from '../../containers/LanguageProvider/actions';

import style from './style.module.scss';

function Header(props) {

  const handleModalOpen = () => {
    props.handleModalOpen(true);
  }
  const navLogo = getLogoAsPerTheme(props.theme.toLowerCase(), 'logo_new.png');

  return (
    <div className={style.navbar}>
      <Img
        className={style.navbarLogo}
        src={navLogo.default ?? navLogo}
        alt="amazon pay"
      />
      {
        props.userId && !props.isSales &&
        <div className={style.languageSelect} onClick={handleModalOpen}>
          <span className={`material-icons ${style.languageIcon}`}>language</span>
          <div className={style.languageCode}>{props.language.toUpperCase()}</div>
        </div>
      }
    </div>
  );
}

Header.propTypes = {
  theme: PropTypes.string,
};

const mapStateToProps = state => ({
  userId: state.app.userId,
  isSales: state.app.isSales,
  language: state.language.language,
});

function mapDispatchToProps(dispatch) {
  return {
    handleModalOpen: open => dispatch(handleLanguageSelectModal(open)),
    dispatch,
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(withConnect)(Header);